import { Store } from '@ngrx/store';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, Input, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: "tr-tel",
    templateUrl: "./tr-tel.component.html",
    styleUrls: ["./tr-tel.component.scss"],
})
export class TrTelComponent extends TrInputComponent {
    @Input() public minLength = "10";
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    constructor(private render: Renderer2, store: Store<AppState>) {
        super(store);
    }
}
